"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Trigger;
var _react = _interopRequireWildcard(require("react"));
var _cccisdApollo = require("cccisd-apollo");
var _chart = _interopRequireDefault(require("cccisd-icons/chart"));
var _cross = _interopRequireDefault(require("cccisd-icons/svg/cross"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _useDebounce3 = require("use-debounce");
var _List = _interopRequireDefault(require("./List"));
var _Header = _interopRequireDefault(require("./Header"));
var _Content = _interopRequireDefault(require("./Content"));
var _Settings = _interopRequireDefault(require("./Settings"));
var _VizReport = _interopRequireDefault(require("./VizReport"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _utils = require("./Settings/utils.js");
var _getDataToVisualize = require("./getDataToVisualize.js");
var _populateMetric = _interopRequireDefault(require("./populateMetric.js"));
var _variablesWithContent = _interopRequireDefault(require("./variablesWithContent.graphql"));
var _rolesForGroupComparison = _interopRequireDefault(require("./rolesForGroupComparison.graphql"));
var _groupsForGroupComparison = _interopRequireDefault(require("./groupsForGroupComparison.graphql"));
var _uniqBy2 = _interopRequireDefault(require("lodash/uniqBy"));
var _admin = require("../../../selectors/admin.js");
var _reactRedux = require("react-redux");
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Fortress = window.cccisd.fortress;
var counter = 0;
function Visualize(props) {
  var metrics = props.metrics,
    deploymentIds = props.deploymentIds,
    deployments = props.deployments,
    tableFilters = props.tableFilters,
    tableSelectedRows = props.tableSelectedRows,
    renderSaveQueryButton = props.renderSaveQueryButton,
    currentQuerySettings = props.currentQuerySettings,
    closeModal = props.closeModal,
    overrideInitialVisualizeSettings = props.overrideInitialVisualizeSettings,
    applyPawnContext = props.applyPawnContext,
    _props$showSettings = props.showSettings,
    showSettings = _props$showSettings === void 0 ? true : _props$showSettings;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    search = _useState2[0],
    setSearch = _useState2[1];
  var _useState3 = (0, _react.useState)(metrics[0].variableId),
    _useState4 = _slicedToArray(_useState3, 2),
    currentMetricId = _useState4[0],
    setCurrentMetricId = _useState4[1];
  var _useState5 = (0, _react.useState)(currentQuerySettings.visualizationSettings || {}),
    _useState6 = _slicedToArray(_useState5, 2),
    settings = _useState6[0],
    setSettings = _useState6[1];
  var _useDebounce = (0, _useDebounce3.useDebounce)(search, 500),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedSearch = _useDebounce2[0];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = _slicedToArray(_useState7, 2),
    vizData = _useState8[0],
    setVizData = _useState8[1];
  var _useState9 = (0, _react.useState)([]),
    _useState0 = _slicedToArray(_useState9, 2),
    groupComparisonOptions = _useState0[0],
    setGroupComparisonOptions = _useState0[1];
  var project = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProject)(state.assignment.admin);
  });
  var assignmentId = currentQuerySettings.assignmentId;
  var includeIdentifiable = Fortress.hasAccess('quest.view_identifiable_data', project.groupId);
  var filteredMetrics = (0, _react.useMemo)(function () {
    var lowerCaseSearch = debouncedSearch.toLowerCase();
    return metrics.map(function (item, index) {
      return _objectSpread(_objectSpread({}, item), {}, {
        page: index + 1
      });
    }).filter(function (item) {
      return lowerCaseSearch.length === 0 || item.reportHeader.toLowerCase().includes(lowerCaseSearch);
    });
  }, [metrics, debouncedSearch]);
  var _useMemo = (0, _react.useMemo)(function () {
      var ids = filteredMetrics.map(function (m) {
        return m.variableId;
      });
      var currentIndex = ids.indexOf(currentMetricId);
      return {
        prevMetricId: currentIndex === -1 ? null : ids[currentIndex - 1] || null,
        nextMetricId: currentIndex === -1 ? null : ids[currentIndex + 1] || null
      };
    }, [filteredMetrics, currentMetricId]),
    prevMetricId = _useMemo.prevMetricId,
    nextMetricId = _useMemo.nextMetricId;
  var currentMetric = (0, _react.useMemo)(function () {
    return (0, _populateMetric["default"])(metrics.find(function (item) {
      return item.variableId === currentMetricId;
    }));
  }, [metrics, currentMetricId]);
  var currentMetricSettings = (0, _react.useMemo)(function () {
    return (0, _utils.getActualMetricSettings)(currentMetric, settings[currentMetricId], overrideInitialVisualizeSettings);
  }, [currentMetric, settings[currentMetricId], overrideInitialVisualizeSettings]);
  var currentCrossMetric = (0, _react.useMemo)(function () {
    if (!currentMetricSettings.compareWith) {
      return null;
    }
    var reportHeader = currentMetricSettings.compareWith.replace('variables.', '');
    return (0, _populateMetric["default"])(metrics.find(function (item) {
      return item.reportHeader === reportHeader;
    }));
  }, [metrics, currentMetricSettings]);
  var hasSettingsDiff = (0, _react.useMemo)(function () {
    return !(0, _isEqual2["default"])(settings, currentQuerySettings.visualizationSettings);
  }, [settings, currentQuerySettings]);
  (0, _react.useEffect)(function () {
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var roles, response, options, _response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _cccisdApollo.client.query({
              query: _rolesForGroupComparison["default"],
              variables: {
                deploymentIds: deploymentIds
              }
            });
          case 1:
            response = _context.v;
            roles = response.data.flows.deploymentList.reduce(function (obj, item) {
              obj.add(item.role);
              (item.settings.otherAllowedRoles || []).forEach(function (role) {
                obj.add(role);
              });
              return obj;
            }, new Set());

            // don't consider these roles
            roles["delete"]('uberadmin');
            roles["delete"]('questprojectadmin');
            _context.n = 2;
            return _cccisdApollo.client.query({
              query: _groupsForGroupComparison["default"],
              variables: {
                roles: _toConsumableArray(roles)
              }
            });
          case 2:
            _response = _context.v;
            options = _response.data.roles.anyRole.ancestorGroups.anyGroupList.filter(function (g) {
              return g.group.groupType !== 'questorganization' && g.group.groupType !== 'questproject';
            }).map(function (g) {
              var _window, _window$cccisd, _window$cccisd$appDef, _window$cccisd$appDef2, _window2, _window2$cccisd, _window2$cccisd$appDe, _window2$cccisd$appDe2, _window2$cccisd$appDe3, _window2$cccisd$appDe4;
              return {
                value: g.group.groupType,
                label: (_window = window) !== null && _window !== void 0 && (_window$cccisd = _window.cccisd) !== null && _window$cccisd !== void 0 && (_window$cccisd$appDef = _window$cccisd.appDefs) !== null && _window$cccisd$appDef !== void 0 && (_window$cccisd$appDef2 = _window$cccisd$appDef.pawn) !== null && _window$cccisd$appDef2 !== void 0 && _window$cccisd$appDef2.groups ? (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$cccisd = _window2.cccisd) === null || _window2$cccisd === void 0 ? void 0 : (_window2$cccisd$appDe = _window2$cccisd.appDefs) === null || _window2$cccisd$appDe === void 0 ? void 0 : (_window2$cccisd$appDe2 = _window2$cccisd$appDe.pawn) === null || _window2$cccisd$appDe2 === void 0 ? void 0 : (_window2$cccisd$appDe3 = _window2$cccisd$appDe2.groups) === null || _window2$cccisd$appDe3 === void 0 ? void 0 : (_window2$cccisd$appDe4 = _window2$cccisd$appDe3.find(function (gr) {
                  return gr.handle === g.group.groupType;
                })) === null || _window2$cccisd$appDe4 === void 0 ? void 0 : _window2$cccisd$appDe4.label : g.group.groupType
              };
            });
            setGroupComparisonOptions(options);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }, []);
  var updateMetricSettings = function updateMetricSettings(metric, values) {
    var settingsToSave = (0, _utils.getMetricSettingsToSave)(metric, values);
    if (!settingsToSave) {
      setSettings((0, _omit2["default"])(settings, [metric.variableId]));
    } else {
      setSettings(_objectSpread(_objectSpread({}, settings), {}, _defineProperty({}, metric.variableId, settingsToSave)));
    }
  };
  var cleanCurrentMetricVizData = function cleanCurrentMetricVizData() {
    setVizData(function (prev) {
      return (0, _omit2["default"])(prev, [currentMetricId]);
    });
  };
  (0, _react.useEffect)(function () {
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var res;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return (0, _getDataToVisualize.getDataToVisualize)({
              assignmentId: assignmentId,
              deploymentIds: deploymentIds,
              metric: currentMetric,
              metricSettings: currentMetricSettings,
              querySettings: currentQuerySettings,
              tableFilters: tableFilters,
              tableSelectedRows: tableSelectedRows,
              applyPawnContext: applyPawnContext,
              includeIdentifiable: includeIdentifiable
            });
          case 1:
            res = _context2.v;
            setVizData(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, currentMetricId, res));
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }))();
  }, [currentMetricId, currentMetricSettings.comparison, currentMetricSettings.compareWith, currentMetricSettings.compareByGroupType]);

  // fetch data for all metrics
  (0, _react.useEffect)(function () {
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var promises;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            _context4.n = 1;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 1000);
            });
          case 1:
            promises = metrics.filter(function (metric) {
              return !vizData[metric.variableId];
            }).map(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(metric) {
                var res;
                return _regenerator().w(function (_context3) {
                  while (1) switch (_context3.n) {
                    case 0:
                      _context3.n = 1;
                      return (0, _getDataToVisualize.getDataToVisualize)({
                        assignmentId: assignmentId,
                        deploymentIds: deploymentIds,
                        metric: metric,
                        metricSettings: (0, _utils.getActualMetricSettings)(metric, settings[metric.variableId], overrideInitialVisualizeSettings),
                        querySettings: currentQuerySettings,
                        tableFilters: tableFilters,
                        tableSelectedRows: tableSelectedRows,
                        applyPawnContext: applyPawnContext,
                        includeIdentifiable: includeIdentifiable
                      });
                    case 1:
                      res = _context3.v;
                      setVizData(function (prev) {
                        return prev[metric.variableId] ? prev : _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, metric.variableId, res));
                      });
                    case 2:
                      return _context3.a(2);
                  }
                }, _callee3);
              }));
              return function (_x) {
                return _ref4.apply(this, arguments);
              };
            }());
            Promise.resolve(promises);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }))();
  }, []);
  function handleClose() {
    _cccisdApollo.taskMasterClient.cancelQueries('viz');
    closeModal();
  }
  var saveQueryButton = renderSaveQueryButton({
    hasChanges: hasSettingsDiff,
    currentQuerySettings: _objectSpread(_objectSpread({}, currentQuerySettings), {}, {
      visualizationSettings: settings
    })
  });
  var renderVizReport = function renderVizReport() {
    return /*#__PURE__*/_react["default"].createElement(_VizReport["default"], {
      metrics: metrics,
      vizData: vizData,
      deployments: deployments,
      settings: settings,
      overrideInitialVisualizeSettings: overrideInitialVisualizeSettings
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].backdrop
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].modal,
    "data-visualize-area": true
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "",
    className: (0, _classnames["default"])(_style["default"].closeButton, !showSettings && _style["default"].onLightBackground),
    onClick: function onClick(e) {
      e.preventDefault();
      handleClose();
    },
    "data-visualize-close-button": true
  }, /*#__PURE__*/_react["default"].createElement(_cross["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    metrics: metrics,
    filteredMetrics: filteredMetrics,
    search: search,
    setSearch: setSearch,
    currentMetricId: currentMetricId,
    setCurrentMetricId: setCurrentMetricId
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(!showSettings && _style["default"].withCloseButton)
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    prevMetricId: prevMetricId,
    nextMetricId: nextMetricId,
    setCurrentMetricId: setCurrentMetricId,
    saveQueryButton: saveQueryButton,
    renderVizReport: renderVizReport,
    metrics: metrics
  })), /*#__PURE__*/_react["default"].createElement(_Content["default"], {
    key: currentMetricId,
    currentMetric: currentMetric,
    currentCrossMetric: currentCrossMetric,
    prevMetricId: prevMetricId,
    nextMetricId: nextMetricId,
    setCurrentMetricId: setCurrentMetricId,
    currentMetricSettings: currentMetricSettings,
    deployments: deployments,
    data: vizData[currentMetricId]
  })), showSettings && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].settings
  }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], {
    key: currentMetricId,
    currentMetric: currentMetric,
    currentMetricSettings: currentMetricSettings,
    currentCrossMetric: currentCrossMetric,
    updateMetricSettings: updateMetricSettings,
    metrics: metrics,
    cleanCurrentMetricVizData: cleanCurrentMetricVizData,
    groupComparisonOptions: groupComparisonOptions,
    data: vizData[currentMetricId]
  }))));
}
function Trigger(props) {
  var metrics = props.metrics,
    deploymentIds = props.deploymentIds,
    currentQuerySettings = props.currentQuerySettings,
    renderVisualizeButton = props.renderVisualizeButton;
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isOpen = _useState10[0],
    setIsOpen = _useState10[1]; // big modal state
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    metricsData = _useState12[0],
    setMetricsData = _useState12[1];
  (0, _react.useEffect)(function () {
    if (metrics.length === 0) {
      return;
    }
    _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var currentCounter, response, result;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            currentCounter = ++counter;
            setMetricsData(null);
            _context5.n = 1;
            return _cccisdApollo.client.query({
              query: _variablesWithContent["default"],
              variables: {
                assignmentId: [currentQuerySettings.assignmentId],
                reportHeaders: metrics
              },
              fetchPolicy: 'network-only',
              errorPolicy: 'all'
            });
          case 1:
            response = _context5.v;
            if (!(currentCounter !== counter)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2);
          case 2:
            // we need deduplicate list as we could have the same reportHeader for different languages
            result = (0, _uniqBy2["default"])(response.data.metrics.variableList, 'reportHeader').map(function (item) {
              var _item$key, _item$key2;
              var m = {
                variableId: item.variableId,
                reportHeader: item.reportHeader,
                surveyHandles: item.surveyHandles,
                type: item.type,
                label: item.label,
                question: item.key.title,
                content: item.key.content,
                isIdentifying: Boolean(item === null || item === void 0 ? void 0 : (_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.isIdentifying),
                questionType: item.key.questionType,
                "enum": (_item$key2 = item.key) === null || _item$key2 === void 0 ? void 0 : _item$key2.enumList,
                enumCoding: item.enumCoding,
                minimum: item.key.minimum,
                maximum: item.key.maximum,
                isFile: item.tagList.some(function (obj) {
                  return obj.scope === 'system' && obj.handle === 'fileUpload';
                })
              };
              m.statisticType = function () {
                if (Object.keys(m.content).includes('enum')) {
                  if (m.enumCoding && (Object.keys(m.enumCoding).every(function (v) {
                    return Number.isInteger(Number(v));
                  }) || Object.values(m.enumCoding).every(function (v) {
                    return Number.isInteger(Number(v));
                  }))) {
                    return ['categorical', 'numeric'];
                  }
                  return ['categorical'];
                }
                return ['numeric'];
              }();
              return m;
            });
            setMetricsData(result);
          case 3:
            return _context5.a(2);
        }
      }, _callee5);
    }))();
  }, [metrics]);
  var disabledReason = function () {
    if (deploymentIds.length === 0) {
      return 'Missing data collection waves';
    }
    if (currentQuerySettings.surveyHandles.length === 0) {
      return 'Missing surveys';
    }
    if (metrics.length === 0) {
      return 'No metrics to visualize';
    }
    return null;
  }();
  var disabled = Boolean(disabledReason);
  var open = function open() {
    if (disabled) {
      return;
    }
    setIsOpen(true);
  };
  var button = function () {
    if (renderVisualizeButton) {
      return renderVisualizeButton({
        open: open,
        disabled: disabled,
        disabledReason: disabledReason
      });
    }
    if (disabled) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: disabledReason.reason
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-secondary",
        disabled: true
      }, /*#__PURE__*/_react["default"].createElement(_chart["default"], {
        spaceRight: true
      }), "Visualize"));
    }
    return /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "btn btn-secondary",
      onClick: open
    }, /*#__PURE__*/_react["default"].createElement(_chart["default"], {
      spaceRight: true
    }), "Visualize");
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, button, function () {
    if (!isOpen || disabled) {
      return null;
    }
    if (!metricsData) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: true
      });
    }
    return /*#__PURE__*/_react["default"].createElement(Visualize, _extends({}, props, {
      metrics: metricsData,
      closeModal: function closeModal() {
        return setIsOpen(false);
      }
    }));
  }());
}